<template>
  <div>
    <div class="flex space-x-3 items-baseline">
      <div class="min-w-0">
        <p class="text-sm font-medium text-gray-900 truncate">
          {{ authorName }}
        </p>
      </div>
      <time
        datetime="2021-01-27T16:35"
        class="flex-shrink-0 whitespace-nowrap text-xs text-gray-500"
        >{{ createdAt }}</time
      >
    </div>
    <div class="mt-1">
      <div class="text-sm text-gray-600 prose prose-sm" v-html="content" />
    </div>
  </div>
</template>

<script>
import { marked } from 'marked';
import moment from 'moment';

export default {
  props: {
    message: {
      type: Object,
      required: true,
    },
  },
  computed: {
    author() {
      if (
        typeof this.message.authorType === 'string' &&
        typeof this.message.authorId === 'string'
      ) {
        return (
          this.$store.state.entities?.[this.message.authorType]?.byId?.[this.message.authorId] ||
          null
        );
      }

      return (
        this.$store.state.entities?.[this.message.authorableType]?.byId?.[
          this.message.authorableId
        ] || null
      );
    },
    authorName() {
      return this.author?.fullName || 'Unknown';
    },
    content() {
      return marked(this.message.content);
    },
    createdAt() {
      return moment(this.message.createdAt).fromNow();
    },
  },
};
</script>
